export const REASONS_FOR_CHANGE_ACTIVITY_STATUS = {
  // NOTE: MUST BE SPACE HERE NOT EMPTY STRING!!!
  OTHER: ' ',
  USER_FORGOT: 'user forgot',
  ACCIDENTALLY_CLICKED: 'accidentally clicked',
}

export const SET_BY_USER_FROM_UI = 'SET_BY_USER_FROM_UI'
